import React from 'react';
import { Link } from 'react-router-dom';
import Copyright from './Copyright';

const FooterThree = () => {
    return(
        <>
        <footer className="footer">
            <div className="default-container">
                <div className="widgets-section">
                    <div className="row clearfix">
                        <div className="big-column col-lg-12">
                            <div className="row clearfix">
                                <div className="footer-col col-lg-3">
                                    <div className="footer-widget logo-widget">
                                        <div className="logo">
                                            <Link to="./"><img src="images/logo-footer.png" alt="okell" /></Link>
                                        </div>
                                        <div className="text">California, TX 70240</div>
                                        <ul className="list-style-one">
                                            <li><span>Phone:</span> +123 456 7890</li>
                                            <li><span>Email:</span> support@example.com</li>
                                            <li><span>Working Hours:</span> Mon - Fri: 9.00am - 5.00pm</li>
                                        </ul>
                                        <ul className="social-icon">
                                            <li><Link to="#"><i className="fa fa-facebook"></i></Link></li>
                                            <li><Link to="#"><i className="fa fa-linkedin"></i></Link></li>
                                            <li><Link to="#"><i className="fa fa-vimeo"></i></Link></li>
                                            <li><Link to="#"><i className="fa fa-pinterest-p"></i></Link></li>
                                            <li><Link to="#"><i className="fa fa-instagram"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="footer-col col-lg-3">
                                    <div className="footer-widget posts-widget">
                                        <h2>Recent Posts</h2>
                                        <article className="post">
                                            <div className="text"><Link to="blog-single.html">You want to know industrial laws</Link></div>
                                            <ul className="post-date">
                                                <li>By Admin</li>
                                                <li>JAN 25 2022</li>
                                            </ul>
                                        </article>
                                        <article className="post">
                                            <div className="text"><Link to="blog-single.html">You want to know industrial laws</Link></div>
                                            <ul className="post-date">
                                                <li>By Admin</li>
                                                <li>JAN 25 2022</li>
                                            </ul>
                                        </article>
                                        <article className="post">
                                            <div className="text"><Link to="blog-single.html">You want to know industrial laws</Link></div>
                                            <ul className="post-date">
                                                <li>By Admin</li>
                                                <li>JAN 25 2022</li>
                                            </ul>
                                        </article>
                                    </div>
                                </div>
                                <div className="footer-col col-lg-3">
                                    <div className="footer-widget links-widget">
                                        <h2>Quick Links</h2>
                                        <ul className="footer-link">
                                            <li><Link to="#">About Us</Link></li>
                                            <li><Link to="#">Practice</Link></li>
                                            <li><Link to="#">Testimonials</Link></li>
                                            <li><Link to="#">Attorney</Link></li>
                                            <li><Link to="#">Latest News</Link></li>
                                            <li><Link to="#">Privacy Policy</Link></li>
                                            <li><Link to="#">Contact Us</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="footer-col col-lg-3">
                                    <div className="footer-widget newsletter-widget">
                                        <h2>Get In Touch</h2>
                                        <div className="text">Get in your inbox the latest News and Offers from Okell</div>
                                        <div className="newsletter-form">
                                            <form method="post" action="contact-us.html">
                                                <div className="form-group">
                                                    <input type="email" name="email" value="" placeholder="Email address" required />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="o-btn btn-style-seven">Subscribe</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Copyright />
        </footer>
        </>
    )
}

export default FooterThree;